import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { formatarErroApi } from "@/api";
import { Trophy, Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login } = useAutenticacao();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  const submeter = async (e) => {
    e.preventDefault();
    setErro("");
    setEnviando(true);
    try {
      const usuario = await login(email, senha);
      const destino = location.state?.from?.pathname;
      if (destino) {
        navigate(destino, { replace: true });
      } else if (usuario.perfil === "SUPER_ADMIN" || usuario.perfil === "ADMINISTRADOR") {
        navigate("/admin", { replace: true });
      } else if (!usuario.regulamentoAceito) {
        navigate("/aceitar-regulamento", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    } catch (err) {
      setErro(formatarErroApi(err));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-superficie-base text-white flex items-center justify-center p-6" data-testid="pagina-login">
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/15f31867-a42b-4fb8-8b3e-49ddef9b80ee/images/709fb6d2fdf49b385d53108a6791fccc0f0269965c9b69cf0e842e7b295561b8.png"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10 justify-center" data-testid="link-voltar-home">
          <div className="w-10 h-10 rounded-md bg-verdebrasil flex items-center justify-center glow-green">
            <Trophy className="w-5 h-5 text-amarelobrasil" />
          </div>
          <div>
            <div className="font-heading font-bold uppercase text-base leading-none">Bolão da Copa</div>
            <div className="text-[10px] tracking-[0.3em] text-amarelobrasil uppercase">FIFA 2026</div>
          </div>
        </Link>

        <div className="surface-card rounded-2xl p-8 relative overflow-hidden">
          <div className="absolute top-0 left-0 h-1 w-full stripe-brasil opacity-60" />
          <h1 className="font-heading uppercase text-2xl font-bold mb-1">Entrar</h1>
          <p className="text-sm text-white/60 mb-6">Acesse sua conta para palpitar e acompanhar o ranking.</p>

          <form onSubmit={submeter} className="space-y-4">
            <div>
              <label className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-bold">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full bg-superficie-base border border-white/10 rounded-lg px-4 py-3 text-sm focus:border-verdebrasil focus:outline-none focus:ring-1 focus:ring-verdebrasil"
                required
                data-testid="input-email"
              />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-bold">Senha</label>
              <div className="relative mt-1">
                <input
                  type={mostrarSenha ? "text" : "password"}
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  className="w-full bg-superficie-base border border-white/10 rounded-lg px-4 py-3 pr-10 text-sm focus:border-verdebrasil focus:outline-none focus:ring-1 focus:ring-verdebrasil"
                  required
                  data-testid="input-senha"
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white"
                  tabIndex={-1}
                >
                  {mostrarSenha ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {erro && (
              <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 px-3 py-2 rounded-md" data-testid="msg-erro-login">
                {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={enviando}
              className="w-full py-3 rounded-md font-heading uppercase tracking-widest text-sm bg-verdebrasil hover:bg-verdebrasil-dark transition-all hover:glow-green disabled:opacity-50"
              data-testid="btn-entrar"
            >
              {enviando ? "Entrando..." : "Entrar"}
            </button>
          </form>

          <div className="mt-6 text-sm text-center text-white/60">
            Acesso restrito a apostadores cadastrados pela administração.
          </div>
        </div>
      </div>
    </div>
  );
}
